// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___Qbf6h","open":"open___1wrkh","header":"header___3MmmO"};